import * as React from 'react';
import { Converter } from 'showdown';
import StaticView from './StaticView';
import RichTextEditor from 'common/components/RtEditor';

export default class RichText extends React.Component<any, any> {
    /**
     * 富文本编辑器内容改变事件处理
     * @param content
     */
    richTextHandler = (content: any) => {
        const { onChange } = this.props;
        onChange(content);
    };

    /**
     * 提取纯文本
     * @returns {any}
     */
    getContent = (value: any) => {
        return (value.replace(/<[^>]*/g, "").split('>') || []).filter((e: any) => !!e);
    };

    /**
     * 获取缩略文本
     * @returns {any}
     */
    getThumbnailText = (value: any) => {
        return `${this.getContent(value).slice(0, 2).join(',')}...`;
    };

    render() {
        const { value, format, extra, disabled, staticView, thumbnail, wrap, target, onCall, menu, isRelativeUrl } = this.props;
        return (
            (staticView && disabled)
                ? <StaticView wrap={wrap} display={value} adaptFn={(value: any) => {
                    if (thumbnail) {
                        return <div>{this.getThumbnailText(value)}</div>;
                    } else {
                        let content = format === 'markdown' ? new Converter().makeHtml(value) : value;
                        let contentSelf = target === '_self' ? content.replace('_blank','_self') : content;    // 当前页面打开下载页
                        return <a className={'retContent'} dangerouslySetInnerHTML={{ __html: contentSelf }}/>;
                    }
                }}/>
                : <RichTextEditor isRelativeUrl={isRelativeUrl} onChange={this.richTextHandler} value={value} tips={extra} menu={menu} imgOnCall={onCall}/>
        );
    }
}
